import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection, In, getManager } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse, FgStatusEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { LotCodeOpsRepository } from './repositories/lot-code.repository';
import { LotCodeOpsAdapter } from './dto/lot-code.adapter';
import { LotCodeOpsEntity } from './entities/lot-code.entity';
import { LotCodeOpsDTO } from './dto/lot-code.dto';
import { LotCodeOpsRequest } from './dto/lot-code-request';
import { AllLotCodeOpsResponseModel, LotCodeDropDown, LotCodeDropDownResponse, LotCodeOpsData, LotCodeOpsResponseModel, OperationandLotReq } from '@gtpl/shared-models/production-management';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ApiGatewayTimeoutResponse } from '@nestjs/swagger';
import { CommonResponse, MasterInfoFromIndentRequest, MasterInfoFromIndentResponse, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { SuppliersService } from '@gtpl/shared-services/masters';
import { SoSoItemRequest } from './dto/lot-no-for-so.request';
import appSettings from 'apps/services/config';
import { ItemsDetails, SaleOrderItemsDropdownResponse, SoNumbersModel, SoNumbersResponseModel } from '@gtpl/shared-models/sale-management';
import { SoIdRequest } from './dto/so-id.request';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable = appSettings.sales_db + '.sale_order_items';
const salesInvTable = appSettings.sales_db + '.so_invoice_details';
const lotCodeTable = appSettings.production_db + '.lot_code_data';
@Injectable()
export class LotCodeOpsService {
  constructor(
    @InjectRepository(LotCodeOpsRepository)
    private lotCodeOpsRepo: LotCodeOpsRepository,
    private lotCodeOpsAdapter: LotCodeOpsAdapter,
    private saleOrderService: SaleOrderService,
    private supplierService: SuppliersService,
  ) { }

  async getLotCodeOpsDetailsWithoutRelations(lotNumber: string): Promise<LotCodeOpsEntity> {
    // tslint:disable-next-line: typedef
    const lotCodeOpsResponse = await this.lotCodeOpsRepo.findOne({
      where: { lotNumber: Raw(alias => `lot_number = '${lotNumber}'`) },
    });
    if (lotCodeOpsResponse) {
      return lotCodeOpsResponse;
    } else {
      return null;
    }
  }

  async createLotCodeOps(lotCodeOpsDto: LotCodeOpsDTO, isUpdate: boolean): Promise<LotCodeOpsResponseModel> {
    // console.log(statesDto);

    try {
      // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
      if (!isUpdate) {
        const lotCodeOpsEntity = await this.getLotCodeOpsDetailsWithoutRelations(lotCodeOpsDto.lotNumber);
        if (lotCodeOpsEntity) {
          //return new InformationMessageError(11104, "State already exists");
          throw new ErrorResponse(11104, 'LotCodeOps already exists');
        }
      }
      else {
        const lotCodeOpsEntity = await this.getLotCodeOpsDetailsWithoutRelations(lotCodeOpsDto.lotNumber);
        if (lotCodeOpsEntity) {
          if (lotCodeOpsEntity.lotNumber != lotCodeOpsDto.lotNumber) {
            throw new ErrorResponse(11104, 'LotCodeOps already exists');
          }
        }
      }
      const convertedLotCodeOpsEntity: LotCodeOpsEntity = this.lotCodeOpsAdapter.convertDtoToEntity(lotCodeOpsDto, isUpdate);
      const savedLotCodeOpsEntity: LotCodeOpsEntity = await this.lotCodeOpsRepo.save(
        convertedLotCodeOpsEntity
      );
      const savedlotCodeOpsDto: LotCodeOpsDTO = this.lotCodeOpsAdapter.convertEntityToDto(convertedLotCodeOpsEntity);
      // console.log(savedStateDto);
      if (savedlotCodeOpsDto) {
        // generating resposnse
        const response = new LotCodeOpsResponseModel(true, 1, isUpdate ? 'LotCodeOps Updated Successfully' : 'LotCodeOps Created Successfully');
        return response
      } else {
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106, 'LotCodeOps saved but issue while transforming into DTO');
      }
    } catch (error) {
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef
      return error;
    }
  }

  async getAllLotOps(plantId: number): Promise<AllLotCodeOpsResponseModel> {
    // const page: number = 1;
    // try {
    //   const lotCodeOpsDTO: LotCodeOpsData[] = [];
    //   //retrieves all companies
    //   const lotCodeOpsEntity = await this.lotCodeOpsRepo.getAllLotData(plantId)
    //   // console.log('lotcodeData-------',lotCodeOpsEntity,'>>>>>>>>>');
    //   if (lotCodeOpsEntity.length === 0) {
    //     throw new ErrorResponse(10000, 'No Records Found');
    //   }
    //   for (const lotData of lotCodeOpsEntity) {
    //     const soInfo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: lotData.saleOrderId })
    //     const soREq: saleOrder = {
    //       saleOrderId: lotData.saleOrderId
    //     }
    //     const soItemInfo = await this.saleOrderService.getSaleOrderItemsForSo(soREq);
    //     const masterResponse: MasterInfoFromIndentResponse = await this.supplierService.getMastersRelatedDataFromIndent(new MasterInfoFromIndentRequest(lotData.farmer, lotData.farmerCode, 1, 1, 1));
    //     console.log(lotData.grnDate,'--data--')
    //      lotCodeOpsDTO.push(new LotCodeOpsData(
    //        lotData.lotCodeOpsId, 
    //        lotData.grnDate, 
    //        lotData.indentId, 
    //        lotData.grnNumber,
    //        lotData.lotNumber,
    //        lotData.saleOrderId,
    //        soInfo.saleOrderNumber, 
    //        lotData.saleOrderItemId,
    //        soItemInfo?.data?.itemsDetails[0]?.item,
    //        lotData.supplierType,
    //        lotData.farmer,
    //        lotData.farmerCode,
    //        lotData.quantity,
    //        lotData.count,
    //        lotData.price,
    //        lotData.boxes,
    //        lotData.plantId,
    //        lotData.subPlantId,
    //        lotData.createdAt, 
    //        lotData.createdUser,
    //        lotData.updatedAt,
    //        lotData.updatedUser,
    //        lotData.isActive,
    //        lotData.versionFlag,
    //        masterResponse?.data?.farmerName,
    //        masterResponse?.data?.farmerCode,
    //        masterResponse?.data?.supplierName, 
    //        masterResponse?.data?.supplierCode,
    //        soInfo.poNumber,
    //        lotData.concatLotNum))
    //     console.log(lotCodeOpsDTO,'dto');
    //   }
    //   const response = new AllLotCodeOpsResponseModel(true, 1, 'Lot Code Info retrieved successfully', lotCodeOpsDTO);
    //   // console.log(response,'^^^^^^^^^^');
    //   // const newLogDto = new LogsDto(1,'view', 'Countries', 0, true, '','')
    //   //       let res = await this.logService.createLog(newLogDto);
    //   //       console.log(res);
    //   return response;

    // } catch (err) {
    //   return err;
    // }
    try{
    const manager = getManager();
    let query 
    const planttype='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
    const result =await manager.query(planttype);
    query ='SELECT g.remarks as plantLotNumber,b.brand_name,f.name AS farmerName,f.code AS farmerCode,sd.po_number AS poNumber,CONCAT(b.brand_name,"-",sk.variant_code) AS itemName,sk.variant_code,CONCAT(g.lot_number,IF(g.remarks IS NOT NULL,"-",""),IF(g.remarks IS NOT NULL ,g.remarks ,"")) AS concatLotNum,lc.lot_code_id AS lotCodeOpsId ,lc.grn_date AS grnDate,lc.plant_id AS plantId,lc.sub_plant_id AS subPlantId,lc.indent_no AS indentId,lc.grn_number AS grnNumber,lc.lot_number AS lotNumber,lc.sale_order_id AS saleOrderId, lc.sale_order_item_id AS saleOrderItemId,lc.supplier_type AS supplierType ,lc.farmer AS farmer,lc.farmer_code AS farmerCode ,lc.quantity AS quantity,lc.count AS count, lc.price AS price ,lc.boxes AS boxes FROM '+appSettings.production_db+'.lot_code_data lc LEFT JOIN '+appSettings.rm_procure_db+'.grn_items g ON g.lot_number = lc.lot_number LEFT JOIN '+appSettings.sales_db+'.so_invoice_details sd ON lc.sale_order_id = sd.sale_order_id LEFT JOIN '+appSettings.sales_db+'.`sale_order_items` si ON si.sale_order_id=lc.sale_order_id LEFT JOIN '+appSettings.masters_db+'.`sku_codes` sk ON sk.sku_code_id=si.varient_id LEFT JOIN '+appSettings.masters_db+'.brands b ON b.brand_id=si.brand_id LEFT JOIN '+appSettings.masters_db+'.farms f ON f.farm_id=lc.farmer WHERE lot_code_id>0 '
      if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
        query = query + ' and sub_plant_id='+plantId+' group by lot_code_id'
      }
      // if(plantId && plantId!=5){
      //   query=query +' and plant_id='+plantId+' and sub_plant_id=0 group by lot_code_id'
      // }
      else{
        if( plantId!=5){
          query=query +' and plant_id='+plantId+' and sub_plant_id=0 group by lot_code_id'
        }else{
          query=query +' and sub_plant_id=0 group by lot_code_id'
        }
      }  
      const data = await manager.query(query)
      if(data.length > 0){
        return new AllLotCodeOpsResponseModel(true,1000,'DataRetrieved sucesfullyy....',data)
      }else{
        return new AllLotCodeOpsResponseModel(false,1000,'No Data Found',data)

      }

    }
    catch(err){
      return err;
    }
  }

  async activateOrDeactivateprodInv(lotCodeOpsRequest: LotCodeOpsRequest): Promise<LotCodeOpsResponseModel> {
    try {
      const lotCodeOpsExists = await this.getLotCodeOpsById(lotCodeOpsRequest.lotCodeOpsId);
      if (lotCodeOpsExists) {
        if (lotCodeOpsRequest.versionFlag !== lotCodeOpsExists.versionFlag) {
          throw new ErrorResponse(10113, 'Someone updated the current lotCodeOps information.Refresh and try again');
        } else {

          const lotCodeOpsStatus = await this.lotCodeOpsRepo.update(
            { lotCodeOpsId: lotCodeOpsRequest.lotCodeOpsId },
            { isActive: lotCodeOpsRequest.isActive, updatedUser: lotCodeOpsRequest.updatedUser });

          if (lotCodeOpsExists.isActive) {
            if (lotCodeOpsStatus.affected) {
              const lotCodeOpsResponse: LotCodeOpsResponseModel = new LotCodeOpsResponseModel(true, 10115, 'lotCodeOps is de-activated successfully');
              return lotCodeOpsResponse;
            } else {
              throw new ErrorResponse(10111, 'lotCodeOps is already deactivated');
            }
          } else {
            if (lotCodeOpsStatus.affected) {
              const lotCodeOpsResponse: LotCodeOpsResponseModel = new LotCodeOpsResponseModel(true, 10114, 'lotCodeOps is activated successfully');
              return lotCodeOpsResponse;
            } else {
              throw new ErrorResponse(10112, 'lotCodeOps is already  activated');
            }
          }
          // }
        }
      } else {
        throw new ErrorResponse(99998, 'No Records Found');
      }
    } catch (err) {
      return err;
    }
  }

  async getLotCodeOpsById(lotCodeOpsId: number): Promise<LotCodeOpsEntity> {
    //  console.log(employeeId);
    const Response = await this.lotCodeOpsRepo.findOne({
      where: { lotCodeOpsId: lotCodeOpsId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }

  async getLotNumbersForBeheading(): Promise<LotCodeDropDownResponse> {
    try {
      const lotCodes: LotCodeDropDown[] = await this.lotCodeOpsRepo.getLotNumbersForBeheading();
      if (lotCodes && lotCodes.length) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', lotCodes)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }

  async getAllLotNumbers(req?: UnitRequest): Promise<LotCodeDropDownResponse> {
    try {
      // const lotCodes: LotCodeDropDown[] = await this.lotCodeOpsRepo.getAllLotNumbers(plantId);
    
      const manager = getManager()
    // const result =await manager.getManager();

      let data=`SELECT lot_code_id AS lotCodeId,l.lot_number AS lotNumber ,l.sub_plant_id AS subPlantId,CONCAT(l.lot_number,IF(g.remarks IS NOT NULL,'-',''),IF(g.remarks IS NOT NULL,g.remarks,'')) AS conacatlotnplantlot,g.remarks AS plantlotNumber FROM `+appSettings.production_db+`.lot_code_data l LEFT JOIN `+appSettings.rm_procure_db+`.grn_items g ON g.lot_number=l.lot_number `
      if(req.unitId){
        data=data +' where l.plant_id='+req.unitId+' GROUP BY l.lot_number'
      }  
      const lotCodes = await manager.query(data)

      if (lotCodes && lotCodes.length ) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', lotCodes)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }

  

  async getSaleOrders(): Promise<SoNumbersResponseModel> {
    try {
      const manager = getManager();
      const query = `SELECT so.sale_order_id as saleOrderId, CONCAT(so.sale_order_no, " - ", inv.po_number) AS saleOrderNumber FROM ` + lotCodeTable + ` s 
      LEFT JOIN `+ salesInvTable + ` inv ON inv.sale_order_id=s.sale_order_id 
      LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=s.sale_order_id 
      group by s.sale_order_id`;

      const soEntities: SoNumbersModel[] = await manager.query(query);
      if (soEntities && soEntities.length > 0) {
        const response = new SoNumbersResponseModel(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soEntities
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (error) {
      return error;
    }
  }

  async getSaleOrderItemsForSo(req: SoIdRequest): Promise<SaleOrderItemsDropdownResponse> {
    try {
      const manager = getManager();
      const query = `SELECT s.sale_order_item_id as saleOrderItemId, concat(b.brand_name, "/", p.name, "/", soi.min_grade_id,'-',soi.max_grade_id) as item FROM ` + lotCodeTable + ` s 
          LEFT JOIN `+ salesSoItemTable + ` soi ON soi.sale_order_item_id=s.sale_order_item_id 
          LEFT JOIN `+ appSettings.masters_db + `.brands b ON b.brand_id=soi.brand_id
          LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id=soi.item_id
          LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
          where s.sale_order_id=`+ req.saleOrderId + `
          group by s.sale_order_item_id`;

      const soEntities: ItemsDetails[] = await manager.query(query);
      if (soEntities && soEntities.length > 0) {
        const response = new SaleOrderItemsDropdownResponse(
          true,
          11108,
          'SO Numbers retrieved successfully',
          soEntities
        );
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (error) {
      return error;
    }
  }

  async getAllLotNumbersForSoItem(req: SoSoItemRequest): Promise<LotCodeDropDownResponse> {
    try {
      const lotCodes: LotCodeDropDown[] = await this.lotCodeOpsRepo.getAllLotNumbersForSoItem(req);
      if (lotCodes && lotCodes.length) {
        return new LotCodeDropDownResponse(true, 1111, 'Lot Numbers retrieved successfully', lotCodes)
      } else {
        throw new ErrorResponse(9999, 'No Lot Numbers Found')
      }

    } catch (error) {
      return error
    }
  }
  async getSonumberforQaQcrejection(req:OperationandLotReq): Promise<CommonResponse> { 
      const manager = getManager();

      let query
      const plantquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.plant;
      const plantresult =await manager.query(plantquery);
      query='SELECT pi.sale_order_item_id as saleOrderItemId,operation,sub_lot_number as subLotNumber,pi.plant_id plantId,pi.sub_plant_id,op_boxes,pi.lot_number as lotNumber,(physical_quantity-issued_quantity-stock_transfer_qty-conversion_quantity) AS availableQuantity,physical_quantity AS physicalQuantity,si.po_number,variant_code,pi.sale_order_id as saleOrderId,lot_number,CONCAT(si.po_number,"-",variant_code) AS salOrderandItem FROM '+appSettings.production_db+'.production_inventory pi LEFT JOIN '+appSettings.sales_db+'.so_invoice_details si ON si.sale_order_id=pi.sale_order_id LEFT JOIN '+appSettings.sales_db+'.sale_order_items soi ON soi.sale_order_item_id=pi.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.sku_codes sk ON sk.sku_code_id=soi.varient_id where pi.sub_lot_number ="'+req.subLotNumber+'" and pi.operation="'+req.operation+'"'

      if(plantresult[0].plant_type == UnitTypeEnum.SUB_PLANT){
        query = query+' and pi.sub_plant_id='+req.plant+' '
      }else{
          query = query+ ' and pi.plant_id='+req.plant+' and  pi.sub_plant_id=0' 
      }
      query = query+' group by pi.sale_order_item_id'

      // const query = 'SELECT CONCAT(si.po_number,"-",b.brand_name,"-",sk.variant_code) AS product,b.brand_name AS brandName,sk.variant_code AS variantCode,si.job_type AS jobtype,ld.sale_order_id AS saleOrderId,ld.sale_order_item_id AS saleOrderItemId,so.sale_order_no AS saleOrderNumber,si.po_number AS poNumber FROM '+appSettings.production_db+'.lot_code_data ld LEFT JOIN  '+appSettings.sales_db+'.sale_order so ON ld.sale_order_id=so.sale_order_id LEFT JOIN '+appSettings.sales_db+'.so_invoice_details si ON ld.sale_order_id=si.sale_order_id LEFT JOIN '+appSettings.sales_db+'.sale_order_items soi ON ld.sale_order_id=soi.sale_order_id LEFT JOIN '+appSettings.masters_db+'.sku_codes sk ON sk.sku_code_id = soi.varient_id LEFT JOIN '+appSettings.masters_db+'.`brands` b ON b.brand_id = soi.brand_id WHERE si.is_sub_contract="NO" AND si.job_type!="Sub Job" GROUP BY ld.sale_order_item_id'
      
      const data= await manager.query(query);
      if (data.length > 0) {
        return new CommonResponse(true, 5555, 'So lifecylce data retrivedd', data)
      } else {
        return new CommonResponse(false, 4444, 'No lifecylce data found')
      }
  }

}

